module.exports = __webpack_public_path__ + "img/no-buy.06b61f69.svg";